var _path, _path2, _rect, _rect2, _g, _path3, _path4, _path5, _g2, _g3, _path6, _path7, _path8, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigsale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 93,
    viewBox: "0 0 368 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 0.5L189.744 45.4362L280 84L237 89L189.744 45.4362L115 13.5L141 0.5Z",
    fill: "url(#paint0_linear_842_229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 69.5L332.5 7L311 71.5L362.5 69.5Z",
    fill: "url(#paint1_linear_842_229)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 340,
    height: 60,
    rx: 30,
    fill: "url(#paint2_linear_842_229)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 19.5,
    width: 339,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint3_linear_842_229)",
    strokeOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_842_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 4.5L48.5 32.5L137.5 30.5L141 0.5L46 4.5Z",
    fill: "url(#paint4_linear_842_229)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 5.5L51.5 9.5L54 29.5L132.5 27L134.5 5.5Z",
    fill: "#E5A4A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 28.5L49.5 17.5L50 31L91.5 29.5L52 28.5Z",
    fill: "#6F1717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139 2L82.5 5L136.5 4V21.5L139 2Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_842_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2706 25.9001L60.4355 11.9251L66.1253 11.5851C66.7918 11.7857 67.3959 12.1703 67.9374 12.739C68.479 13.3077 68.7752 14.018 68.8261 14.8698C68.916 16.3738 68.4863 17.4547 67.5372 18.1125L67.542 18.1923C68.807 18.7979 69.4829 19.8261 69.5696 21.2769C69.669 22.9406 68.9058 24.362 67.2799 25.541L61.2706 25.9001ZM63.4954 17.5325L65.4719 17.4144C66.0361 17.0201 66.2963 16.4569 66.2525 15.7248C66.2088 14.9928 65.9013 14.4302 65.3302 14.0369L63.2938 14.1585L63.4954 17.5325ZM63.8474 23.422L65.9037 23.2991C66.1329 23.1118 66.3296 22.8262 66.4937 22.4424C66.671 22.0578 66.7486 21.6792 66.7263 21.3065C66.704 20.9339 66.6039 20.5992 66.4259 20.3027C66.2479 20.0061 66.0347 19.7917 65.7864 19.6597L63.6302 19.7885L63.8474 23.422ZM71.2723 25.3025L70.4372 11.3274L73.1723 11.164L74.0074 25.139L71.2723 25.3025ZM82.5601 24.6279L78.3277 24.8809C77.3169 24.0597 76.5557 23.0566 76.0441 21.8717C75.5325 20.6868 75.2374 19.4355 75.1586 18.1179C75.0791 16.7869 75.2669 15.46 75.7222 14.1371C76.1774 12.8143 76.8607 11.7316 77.7721 10.8891L82.6234 10.5992L82.7666 12.9949L79.0532 13.2168C78.731 13.6368 78.4693 14.2869 78.2681 15.1671C78.0662 16.034 77.9942 16.9533 78.0523 17.9249C78.1095 18.8832 78.2775 19.7948 78.5563 20.6597C78.8476 21.5105 79.1778 22.1186 79.5469 22.4839L81.4635 22.3693L81.139 16.939L83.7743 16.7815L83.9747 20.1356C84.0844 21.9723 83.6129 23.4697 82.5601 24.6279ZM89.4372 10.192L94.2287 9.90568L94.3718 12.3014L90.5387 12.5305L90.4859 12.6538L94.0286 18.2926C94.7507 19.4248 95.1301 20.2971 95.1667 20.9093C95.247 22.2536 94.86 23.2651 94.0057 23.944L88.7151 24.2601L88.5767 21.9443L92.7093 21.6973L92.7621 21.5739L88.7831 15.3402C88.2084 14.4395 87.9035 13.6964 87.8685 13.1108C87.7858 11.7266 88.3087 10.7537 89.4372 10.192ZM102.684 23.4254L102.132 21.2344L98.978 21.4229L98.6912 23.664L95.976 23.8262L97.8361 9.69011L101.969 9.44316L105.359 23.2655L102.684 23.4254ZM99.9677 12.1674L99.4671 16.8656L99.1698 19.2676L101.665 19.1185L101.064 16.7702L100.008 12.165L99.9677 12.1674ZM106.522 23.196L105.687 9.22097L108.422 9.05753L109.119 20.7167L113.271 20.4686L113.41 22.7845L106.522 23.196ZM114.769 22.7032L113.934 8.72816L121.101 8.29986L121.244 10.6956L116.812 10.9604L117.011 14.2945L120.964 14.0583L121.103 16.3741L117.15 16.6104L117.366 20.2239L121.878 19.9543L122.016 22.2702L114.769 22.7032ZM123.541 19.4742L125.777 19.3406L125.938 22.0358L123.702 22.1694L123.541 19.4742ZM125.402 8.04285L125.484 14.4494L125.65 17.2244L123.414 17.358L123.248 14.583L122.567 8.21226L125.402 8.04285Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_842_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244 9L237 89L326 87L332.5 7L244 9Z",
    fill: "url(#paint5_linear_842_229)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.5 79.5L248.5 16L325 17.5L320 81L246.5 79.5Z",
    fill: "#E5A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5 8.5L252 12L327 12.5L327.5 44.5L330.5 8.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240 85.5L242 57.5L244 82.5L309 85.5H240Z",
    fill: "#6F1717"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_842_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.13 40.0502L264.46 40.3553C266.514 42.0458 267.435 44.0449 267.224 46.3526C267.096 47.7547 266.456 49.272 265.305 50.9044C264.964 51.4035 264.378 52.1745 263.546 53.2177L258.399 59.7272L251.607 59.1049L261.791 45.8548L261.695 45.4484L251.574 44.521L253.059 28.3089L267.431 29.6257L266.949 34.8837L258.405 34.1008L257.835 40.3228C258.746 40.0233 259.844 39.9325 261.13 40.0502ZM282.689 61.9527L274.32 61.1859C272.542 59.0494 271.337 56.612 270.704 53.8735C270.101 51.1377 269.921 48.4407 270.164 45.7825C270.788 38.9763 273.11 33.8869 277.13 30.5144L285.499 31.2811C287.248 33.4149 288.438 35.8511 289.071 38.5895C289.707 41.2988 289.904 43.968 289.663 46.597C289.032 53.4907 286.707 58.6093 282.689 61.9527ZM282.739 36.3304L278.971 35.9851C277.445 38.4963 276.496 41.7821 276.124 45.8424C275.751 49.9028 276.065 53.3926 277.064 56.3119L280.92 56.6652C282.471 53.5671 283.422 50.0901 283.776 46.2343C284.129 42.3784 283.783 39.0771 282.739 36.3304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.887 40.8957L298.816 40.5227C297.382 38.7793 296.766 36.8109 296.967 34.6174C297.202 32.0521 298.177 30.1076 299.891 28.7839L303.962 29.1569C305.408 30.7702 306.013 32.8594 305.778 35.4247C305.577 37.6182 304.613 39.4418 302.887 40.8957ZM301.068 31.591C300.488 32.4001 300.138 33.4552 300.019 34.7564C299.901 36.0391 300.054 37.1309 300.478 38.032L301.705 38.1444C302.29 37.2795 302.639 36.2337 302.751 35.0068C302.866 33.7614 302.713 32.6602 302.295 31.7034L301.068 31.591ZM314.443 49.7992L310.372 49.4262C308.938 47.6828 308.322 45.7144 308.523 43.5209C308.758 40.9556 309.733 39.0111 311.447 37.6874L315.518 38.0604C316.964 39.6737 317.569 41.7629 317.334 44.3282C317.133 46.5217 316.169 48.3453 314.443 49.7992ZM312.624 40.4945C312.044 41.3036 311.694 42.3587 311.575 43.6599C311.457 44.9426 311.61 46.0344 312.034 46.9355L313.261 47.0479C313.846 46.183 314.195 45.1372 314.307 43.9103C314.421 42.6649 314.269 41.5637 313.851 40.6069L312.624 40.4945ZM301.616 48.624L309.595 29.6729L312.745 29.9616L304.656 48.9025L301.616 48.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.477 56.0569C301.251 56.8147 301.789 57.7858 302.09 58.9702C302.391 60.1546 302.486 61.3563 302.374 62.5752C302.264 63.7821 301.962 64.9112 301.468 65.9625C300.974 67.0139 300.26 67.8945 299.328 68.6043L295.635 68.266C294.847 67.3985 294.306 66.4029 294.011 65.2793C293.716 64.1558 293.624 62.9905 293.735 61.7836C293.846 60.5647 294.158 59.4002 294.669 58.2903C295.181 57.1803 295.886 56.3231 296.785 55.7186L300.477 56.0569ZM297.027 66.2967L298.317 66.415C298.648 66.0958 298.95 65.5572 299.224 64.799C299.512 64.03 299.695 63.2094 299.775 62.337C299.855 61.4647 299.829 60.6368 299.696 59.8534C299.564 59.058 299.364 58.4734 299.097 58.0995L297.789 57.9796C297.458 58.2988 297.15 58.8369 296.863 59.5939C296.59 60.3401 296.414 61.1493 296.334 62.0217C296.254 62.894 296.279 63.7339 296.41 64.5412C296.554 65.3376 296.76 65.9228 297.027 66.2967ZM303.199 68.959L304.349 56.4116L310.892 57.0111L310.694 59.162L306.608 58.7876L306.32 61.9245L309.869 62.2496L309.679 64.3289L306.13 64.0037L305.655 69.184L303.199 68.959ZM310.779 69.6535L311.929 57.1061L318.471 57.7055L318.274 59.8565L314.187 59.4821L313.9 62.6189L317.449 62.9441L317.258 65.0234L313.709 64.6982L313.235 69.8785L310.779 69.6535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_842_229",
    x: 46,
    y: 0.5,
    width: 99,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_842_229",
    x: 60.4355,
    y: 8.04297,
    width: 65.8015,
    height: 18.8569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_842_229",
    x: 237,
    y: 7,
    width: 99.5,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_842_229",
    x: 250.249,
    y: 28.3091,
    width: 68.3519,
    height: 43.9438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_229",
    x1: 138,
    y1: 0.999998,
    x2: 240,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_229",
    x1: 326.5,
    y1: 7,
    x2: 361,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159546,
    stopColor: "#C83C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_842_229",
    x1: 184,
    y1: 19,
    x2: 184,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_842_229",
    x1: 184,
    y1: 19,
    x2: 184,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_842_229",
    x1: 115,
    y1: 0.999998,
    x2: 76,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_842_229",
    x1: 306.363,
    y1: 8.28125,
    x2: 250.255,
    y2: 24.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC2323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigsale);
export default __webpack_public_path__ + "static/media/bigsale.5e38ab6b170437ef4388b8cfa6413bfc.svg";
export { ForwardRef as ReactComponent };